import { DecodedAccount } from './DecodedAccount';

export class SHDWFileAccount extends DecodedAccount {
  //
}
